import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { AiFillFacebook } from "react-icons/ai";

const HeaderSocials = () => {
  return (
    <div className="header_socials">
      <a href="https://www.linkedin.com/in/anna-druzhinina/" target="_blank">
        <BsLinkedin />
      </a>
      <a href="https://github.com/annadruzhinina" target="_blank">
        <FaGithub />
      </a>
      <a
        href="https://www.facebook.com/profile.php?id=100010015683151"
        target="_blank"
      >
        <AiFillFacebook />
      </a>
    </div>
  );
};

export default HeaderSocials;
